"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactDropzone = require("react-dropzone");

var _styles = require("./styles");

var _upload_file = _interopRequireDefault(require("../../../assets/images/Icons/upload_file.svg"));

var _jsxRuntime = require("react/jsx-runtime");

var ImageUploader = function ImageUploader(_ref) {
  var handleNewImage = _ref.handleNewImage;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      image = _useState2[0],
      setImage = _useState2[1];

  var onDrop = function onDrop(acceptedFiles) {
    if (acceptedFiles.length === 1) {
      showImage(acceptedFiles[0]);
    }
  };

  var showImage = function showImage(file) {
    var reader = new FileReader();

    reader.onload = function () {
      setImage(reader.result);
      getImageDimensions(reader.result);
    };

    reader.readAsDataURL(file);
  };

  var getImageDimensions = function getImageDimensions(dataURL) {
    var img = new Image();

    img.onload = function () {
      var image = {
        src: dataURL,
        ext: img.src.includes("image/jpeg") ? "jpg" : "png",
        width: img.width,
        height: img.height
      };
      handleNewImage(image);
    };

    img.src = dataURL;
  };

  var _useDropzone = (0, _reactDropzone.useDropzone)({
    onDrop: onDrop
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      isDragActive = _useDropzone.isDragActive;

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ImageUploaderContainer, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, getRootProps()), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", (0, _objectSpread2.default)({}, getInputProps())), image ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      className: "imageLoaded",
      src: image,
      alt: "Imagen Cargada"
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _upload_file.default,
        alt: "Subir im\xE1gen"
      }), isDragActive ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: "Suelta la imagen aqu\xED"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: "Da clic aqu\xED o arrastra la foto para subirla a Content-oh!"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: "Tama\xF1o de imagen recomendando 3000x3000 pixeles"
        })]
      })]
    })]
  }));
};

var _default = ImageUploader;
exports.default = _default;